import * as React from 'react';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Box, Card, Text } from 'roo-ui/components';
import { HorizontalRule } from 'components/Layout/index';

interface ActionBarProps {
  label: string;
  children: React.ReactNode;
}

const ActionContainer = styled(Box)`
  padding: ${themeGet('space.4')};

  > *:not(:first-of-type) {
    margin-top: ${themeGet('space.4')};
  }
`;

export const ActionBar: React.FC<ActionBarProps> = ({ label, children }) => (
  <Card data-testid="booking-action-bar" display="flex" flexDirection="column" textAlign="left" borderRadius="default" p={0}>
    <Text data-testid="booking-action-bar-label" as="div" fontSize="lg" m={4}>
      {label}
    </Text>
    <HorizontalRule m={0} />
    <ActionContainer>{children}</ActionContainer>
  </Card>
);
